<template>
  <div class="FoldersTreeComponent">

    
    <br>
    <ul v-if="isData" :id="id" class="library_ul">
      <ItemTreeFolder :isPending="isPending" :revisionId="revisionId" :action="action" :lang="lang.FolderTreeItem"
        class="item" :model="dataTree" :edit="true" :isLastRevision="isLastRevision" :ownerOfLastRevision="ownerOfLastRevision"></ItemTreeFolder>
    </ul>
    <LoaderComponent v-if="!isData"></LoaderComponent>

  </div>
</template>

<script>
import ItemTreeFolder from "@/components/shared/ItemTreeFolder"
import LoaderComponent from "@/components/shared/LoaderComponent"
import { mapGetters } from 'vuex'


export default {
  name: 'FoldersTreeComponent',
  components: {
    ItemTreeFolder,
    LoaderComponent
  },
  props:{
      iscategory: Boolean,
      reloadTree: Boolean,
      lang: Object,
      action: Boolean,
      revisionId: Number,
      isPending: Boolean,
      lastRevisionHistory: Object
  },
  data: function () {
      return {
        open: true,
        dataItem:{},

        id: "folderTree_"+this._uid,
        name:'',
        searchString: "",
        dataTree: {}
      };
  },
  computed: {

    ...mapGetters({
      
      reloadAfterDeleteTreeFolderItem: 'reloadAfterDeleteTreeFolderItem',
      
    }),
    isData(){


      return this.$store.getters.dataTree.name != ""
    },
    isLastRevision() {
      if (this.lastRevisionHistory == undefined) {
        return
      }
      if (this.lastRevisionHistory.id == this.revisionId) {
        return true;
      }
      return false;
    },
    ownerOfLastRevision() {
      
      if (this.lastRevisionHistory.id == this.revisionId) {
        return this.lastRevisionHistory.userId;
      }
    }
  },
  watch: {
         
    reloadAfterDeleteTreeFolderItem: function(new_isData)
    {
      
      if (new_isData)
      {
        this.loadData();
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_reloadAfterDeleteTreeFolderItem",false )
      }
    },

    reloadTree: function()
    {
      this.loadData();
    },
    revisionId: function (val) {
      
      this.loadData();
    }
  },
  mounted () {
    
    
  },
  created () {
    

    this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteFolderMapping");

    this.loadData();

    //this.setCategory();
  },
  updated() {
    
  },
  methods: {
    loadData(){
      
      let vue = this;
      const obj = {
        revisionId: this.revisionId
      }
      
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getFolderTree", obj)
      .then((result) => {
        console.log(result)
        if (result.status = "OK") {
          
          
          vue.dataTree = result.data;
          
        }
        
      })
    }

  }
}
</script>


<style lang="scss">
  .FoldersTreeComponent{
    
    
    .library_bold {
      font-weight: bold;
    }

    .library_ul label{
      margin-right: 0px;
    }
    .library_li{
      margin-top: 5px;
      margin-left: 0px;
      width: 100%;

    }
    .library_img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
      margin-left: 5px;
    }
    .library_ul {
      padding-left: 3px;
      line-height: 1.5em;
      list-style-type: none;

    }
  }
  


</style>



// WEBPACK FOOTER //
// src/components/shared/FoldersTreeComponent.vue